/* Ambient Home — product page (gallery + sticky add to cart) */
(function () {
  'use strict';

  /* ---- gallery ---- */
  var gal = document.querySelector('[data-pdp-gallery]');
  if (gal) {
    var slides = [].slice.call(gal.querySelectorAll('[data-pdp-slide]'));
    var thumbs = [].slice.call(gal.querySelectorAll('[data-pdp-thumb]'));
    var counter = gal.querySelector('[data-pdp-i]');
    var i = 0;

    function show(n) {
      if (!slides.length) return;
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      if (counter) counter.textContent = String(i + 1);
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-i'), 10) || 0); });
    });
    var prev = gal.querySelector('[data-pdp-prev]');
    var next = gal.querySelector('[data-pdp-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });

    if (slides.length > 1) {
      var x0 = null;
      var stage = gal.querySelector('.pdp__stage');
      stage.addEventListener('touchstart', function (e) { x0 = e.changedTouches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 42) show(dx < 0 ? i + 1 : i - 1);
        x0 = null;
      }, { passive: true });
    }
  }

  /* ---- sticky add to cart: show once the main button is out of view ---- */
  var bar = document.querySelector('[data-pdp-sticky]');
  var atc = document.querySelector('[data-pdp-atc]');
  if (bar && atc && 'IntersectionObserver' in window) {
    bar.hidden = false;
    document.documentElement.classList.add('pdp-sticky-on');
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        bar.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
      });
    }, { rootMargin: '0px 0px -20px 0px' }).observe(atc);
  }
})();
